import {
  defaultFilters,
  type NonFilterParams,
  type SearchFilters,
} from '@cinch-nx/data-search'
import { getDefaultNonFilterParams } from '..'

export function convertSearchFiltersToQueryParams(
  filters: Partial<SearchFilters & NonFilterParams>,
  allCinchStores?: string[],
): URLSearchParams {
  const defaultParams: SearchFilters & NonFilterParams = {
    ...defaultFilters,
    ...getDefaultNonFilterParams(),
  }

  const urlParams = new URLSearchParams()
  const filterEntries = Object.entries(filters)
    // maintain consistent order of keys
    .sort((a, b) => a[0].localeCompare(b[0]))
  for (const [key, value] of filterEntries) {
    if (
      key === 'store' &&
      Array.isArray(value) &&
      value.length === 1 &&
      allCinchStores?.length === 1 &&
      allCinchStores[0] === value[0]
    ) {
      urlParams.set('store', 'all-stores')
    } else if (Array.isArray(value) && value.length > 0) {
      urlParams.set(key, value.join(','))
    } else if (
      value !== defaultParams[key as keyof (SearchFilters & NonFilterParams)]
    ) {
      urlParams.set(key, `${value}`)
    }
  }

  return urlParams
}
